import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateScfRequest = (fileLocation, sowType, sowTechs, sowRmod, sran, sa) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GenerateScf`,
	params: { fileLocation, sowType, sowTechs, sowRmod, sran, sa }
});

export const GetSowListRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetSowList`
});

export const GetSowTypeRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetSowType`
});

export const GetSowTechsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetSowTechs`
});

export const GetSowRmodRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetSowRmod`
});
